export default "__VITE_PUBLIC_ASSET__e815263c__"